const dev = {
  // API_ENDPOINT_URL: "http://localhost:4000",
  PORTAL_ENDPOINT_URL: "https://pmysid.smartworksoffice.com",
  API_ENDPOINT_URL: 'https://dev-erpapi.sworks.sg',
  JIRA_ENDPOINT_URL: "https://dev-jira-backend.sworks.sg/v1/api",
  ENVIRONMENT: "DEV",
  APP_VERSION: "1.7.6",
  S3_PATH: "sworks-sg-uat",
  SITE_DOWN: false
};
const prod = {
  PORTAL_ENDPOINT_URL: "https://pmysid.smartworksoffice.com",
  API_ENDPOINT_URL: 'https://erpapi.sworks.sg',
  JIRA_ENDPOINT_URL: "https://dev-jira-backend.sworks.sg/v1/api",
  ENVIRONMENT: "PROD",
  APP_VERSION: "1.7.6",
  S3_PATH: "sworks-sg-prod",
  SITE_DOWN: false
};
const test = {
  // API_ENDPOINT_URL: "http://localhost:4001",
  PORTAL_ENDPOINT_URL: "https://pmysid.smartworksoffice.com",
  API_ENDPOINT_URL: 'https://uat-erpapi.sworks.sg',
  JIRA_ENDPOINT_URL: "https://dev-jira-backend.sworks.sg/v1/api",
  ENVIRONMENT: "UAT",
  APP_VERSION: "1.7.6",
  S3_PATH: "sworks-sg-uat",
  SITE_DOWN: false
};
const getEnv = () => {
  const appEnv = process.env.REACT_APP_ENV;
  if (appEnv === "dev") return dev;
  if (appEnv === "prod" || appEnv === "production") return prod;
  if (appEnv === "uat") return test;

  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};
export const env = getEnv();
export const S3Path = env.S3_PATH;